import { lazy } from 'react';

import PropTypes from 'prop-types';

import FormModal from '#client/components/FormModal';

const EnterOperatingAddress = lazy(() => import('./components/EnterOperatingAddress'));

export default function EnterOperatingAddressModal({ handleClose }) {
  return (
    <FormModal
      handleBack={handleClose}
      handleClose={handleClose}
    >
      <EnterOperatingAddress handleClose={handleClose} />
    </FormModal>
  );
}

EnterOperatingAddressModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
